<template>
    <summary-messages v-if="showMessage" :message="messageContainer"/>

    <reseller-order-result
        v-else-if="resellerResult"
        :order-number="resellerResult.order_number || ''"
        :reseller="resellerResult.reseller || {}"
        @new-order="onNewOrder"
    />

    <div v-else>
        <h2 class="uk-margin-medium-bottom">{{ $t("Zusammenfassung") }}</h2>
        <summary-receiver/>
        <summary-personalize v-if="store.state.personalize"/>
        <summary-cart :settings="settings"/>
        <summary-payment
            :settings="settings"
            :loginusername="loginusername"
            @success="onSuccess"
            @error="onError"
            @reseller-success="onResellerSuccess"
            @back="$emit('back', 1)"
        />
    </div>
</template>

<script>
import helper from "../../helper/helper";
import SummaryMessages from "./SummaryMessages";
import SummaryReceiver from "./SummaryReceiver";
import SummaryCart from "./SummaryCart";
import SummaryPayment from "./SummaryPayment";
import SummaryPersonalize from "./SummaryPersonalize.vue";
import ResellerOrderResult from "../reseller/ResellerOrderResult.vue";

export default {
    mixins: [helper],
    props: ["settings", "loginusername"],
    components: {
        SummaryPersonalize,
        SummaryMessages,
        SummaryReceiver,
        SummaryCart,
        SummaryPayment,
        ResellerOrderResult,
    },
    data: () => {
        return {
            hasError: false,
            showMessage: false,
            orderNumber: undefined,
            resellerResult: null,
            messageContainer: {
                message: "",
                sorryMessage: "Bitte versuche es später noch einmal.",
                modalDescription: "",
                serverError: false,
                unavailableTickets: false,
                paymentSuccess: false,
            },
        };
    },
    mounted() {
    },
    methods: {
        onSuccess(payload) {
            console.log('success', payload);
        },
        onError(payload) {
            console.log('error', payload);
        },
        onResellerSuccess(response) {
            this.resellerResult = response;
        },
        onNewOrder() {
            // Reseller "next sale": drop server-side cart so the post-reload
            // init() does not prompt "vorherige Eingaben verwenden?", then
            // hard-reload to guarantee a clean shop view (step 0, empty cart,
            // no residual coupon/donation/tender state).
            const reload = () => window.location.reload();
            const forget = this.store.state.doOctoberRequest;
            if (typeof forget === 'function') {
                const result = forget('onForgetStore');
                if (result && typeof result.then === 'function') {
                    result.then(reload, reload);
                    return;
                }
            }
            reload();
        },
    }
};
</script>
